import { search } from 'api/search'
import { TEACHER_DC } from '../../constants'
import { useCallback, useState } from 'react'
import { Box, Flex, Label } from 'theme-ui'
import { GenericSearch } from 'components/GenericSearch'
import { Text } from 'components'
import { ErrorMessage } from 'components/Form'
import { TeacherData } from 'types'

export type TeacherSearchInputProps = {
  onTeacherPicked: (teacher: TeacherData) => void
  tabIndex?: number
}

export const TeacherSearchInput = ({
  onTeacherPicked,
  tabIndex,
}: TeacherSearchInputProps) => {
  const searchTeachers = useCallback(
    async ({ query }: { query: string }) =>
      await search({ query, userType: TEACHER_DC, size: 100 }),
    []
  )
  const [error, setError] = useState<string>('')
  const handleSelection = (teacher: TeacherData) => {
    onTeacherPicked(teacher)
    setError('')
  }
  return (
    <>
      <Label
        htmlFor="TeacherSearchInput"
        sx={{ fontWeight: 600, fontSize: 16 }}>
        Find a teacher
      </Label>
      <GenericSearch
        id="TeacherSearchInput"
        placeholder="Search by email or first+last name"
        limit={100}
        searchFunc={searchTeachers}
        onItemSelected={handleSelection}
        ItemCard={TeacherSearchItem}
        tabIndex={tabIndex}
        onError={setError}
      />
      <ErrorMessage>{error ? <span>{error}</span> : null}</ErrorMessage>
    </>
  )
}

const TeacherSearchItem = ({
  item: teacher,
  onClick,
}: {
  item: TeacherData
  onClick: (item: TeacherData) => void
}) => {
  return (
    <Flex
      variant="layout.result.userSearch"
      data-cy="search-item"
      sx={{
        wordBreak: 'break-word',
        '&:hover': {
          bg: '#fff7e2',
        },
      }}
      onClick={() => onClick(teacher)}>
      <Box sx={{ flex: ['0 0 100%', '1 1 30%'], textAlign: 'left' }}>
        <Box>
          <Text
            variant="text.result"
            sx={{ pl: '2px', fontWeight: 'heading', display: 'inline-block' }}>
            {teacher.forename} {teacher.surname}
          </Text>
          <Text
            variant="text.informational"
            sx={{
              pl: '2px',
              float: 'right',
              fontWeight: 'heading',
              display: ['inline-box', 'none'],
            }}>
            {teacher.countryCode}
          </Text>
        </Box>
        <Text
          variant="text.informational"
          sx={{
            display: ['inline-box', 'none'],
          }}>
          {teacher.email}
        </Text>
      </Box>
      <Box
        sx={{
          flex: ['none', '1 1 55%'],
          textAlign: 'left',
          display: ['none', 'flex'],
        }}>
        <Text
          variant="text.results"
          sx={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontSize: 2,
          }}>
          {teacher.email}
        </Text>
      </Box>
      <Box
        sx={{
          flex: ['none', '1 1 10%'],
          justifyContent: 'center',
          display: ['none', 'flex'],
        }}>
        <Text
          variant="text.results"
          sx={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontSize: 2,
          }}>
          {teacher.countryCode}
        </Text>
      </Box>
    </Flex>
  )
}
